<template>
    <div class="buy-vip-page" v-if="isShow">
        <div class="dialog-mask"></div>
        <div class="buy-vip-content mask-content" @wheel="handleWheel" ref="buyVipContent">
            <div class="real-content">
                <span class="close-icon" @click="close"></span>
                <div class="title">{{ gameInfo.title }}</div>
                <div class="part1">
                    <div class="part1-text">
                        <span class="sp1">1</span>
                        <span class="sp2">选择类型</span>
                    </div>
                    <div class="part1-cont">
                        <div class="line"></div>
                        <div class="account-buy">
                            <p class="p1">账号购买</p>
                            <div v-throttle="[() => chooseAccountType('share'), 'click', 1000]" v-if="shareSpInfo.id && shareSpInfo.can_choose" class="sp share-sp" :class="{ active: accountType === 'share' }">
                                <div class="sp-left">
                                    <i class="i1"></i>
                                    <span class="sp1">共享</span>
                                </div>
                                <div class="sp-center">
                                    <span class="price1">¥{{ shareSpInfo.current_price }}</span>
                                    <span class="price2">¥{{ gameInfo.original_price }}</span>
                                </div>
                                <div class="sp-right">
                                    <div class="text1">游戏共享账号</div>
                                    <div class="text2">永久使用权</div>
                                </div>
                            </div>
                            <div v-throttle="[() => chooseAccountType('alone'), 'click', 1000]" v-if="aloneSpInfo.id && aloneSpInfo.can_choose" class="sp alone-sp" :class="{ active: accountType === 'alone' }">
                                <div class="sp-left">
                                    <i class="i1"></i>
                                    <div class="dv1">
                                        <div class="text1">独享</div>
                                        <div class="text2 ellipsis">{{ aloneSpInfo.s_name }}</div>
                                    </div>
                                </div>
                                <div class="sp-center">
                                    <span class="price1">¥{{ aloneSpInfo.current_price }}</span>
                                    <span class="price2">¥{{ gameInfo.original_price }}</span>
                                </div>
                                <div class="sp-right">
                                    <div class="text1">成品账号</div>
                                    <div class="text1">一人独享</div>
                                </div>
                            </div>
                        </div>
                        <div class="vip-buy">
                            <div class="vip-buy-title">
                                <span class="sp1"></span>
                                <span class="sp2">会员特权</span>
                            </div>
                            <div class="goods-wrap">
                                <div :class="{ active: item.id === currentVipGoods.id }" v-throttle="[() => clickVipGoods(item), 'click', 1000]" class="goods-item" v-for="item in vipGoodsList" :key="item.id">
                                    <span class="sp1">
                                        <i class="i1"></i>
                                        <i class="i2 ellipsis">{{ item.name }}</i>
                                    </span>
                                    <template>
                                        <template v-if="item.showOriginPrice">
                                            <span class="sp2 ellipsis">
                                                <i class="i1">¥</i>
                                                <i class="i2">{{ item.original_price }}</i>
                                            </span>
                                        </template>
                                        <template v-else>
                                            <span class="sp2 ellipsis">
                                                <i class="i1">￥</i>
                                                <i class="i2">{{ item.current_price }}</i>
                                                <i class="i3" v-if="showVipGoodsOrigin(item)">¥{{ item.original_price }}</i>
                                            </span>
                                        </template>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="part2">
                    <div class="part2-text">
                        <span class="sp1">2</span>
                        <span class="sp2">确认充值账号信息</span>
                    </div>
                    <div class="part2-cont">
                        <div class="line"></div>
                        <div class="part2-info" :class="{ 'no-login': !isLogin }">
                            <template v-if="isDyyPage">
                                <div class="btn" @click="dlClient" data-agl-cvt="6">请下载客户端后联系客服</div>
                            </template>
                            <template v-else-if="!isLogin">
                                <div class="btn" @click="openLogin">点击登录</div>
                            </template>
                            <template v-else>
                                <div class="user-info">
                                    <div class="dv1">
                                        <span class="sp sp1 ellipsis">
                                            <i>用户昵称：</i>
                                            <i>{{ username }}</i>
                                        </span>
                                        <span class="sp sp2">
                                            <i>会员剩余时间：</i>
                                            <i>{{ vipText }}</i>
                                        </span>
                                    </div>
                                    <div class="dv2">
                                        <span class="sp sp1 ellipsis">
                                            <i>用户ID：</i>
                                            <i>{{ userInfo.id }}</i>
                                        </span>
                                        <span class="sp sp2">
                                            <i>手机号：</i>
                                            <i>{{ userInfo.mobile ? userInfo.mobile : '未绑定' }}</i>
                                        </span>
                                        <span class="sp">
                                            <i>实名认证：</i>
                                            <i v-if="authInfo.status === 1">已认证</i>
                                            <i v-else class="cert" @click="openAuth">【点击认证】</i>
                                        </span>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="part3">
                    <div class="part3-text">
                        <span class="sp1">3</span>
                        <span class="sp2">确认充值账号信息</span>
                    </div>
                    <div class="part3-cont">
                        <div class="part3-left">
                            <div class="left-content">
                                <div class="qrcode-wrap">
                                    <div class="qrcode-section">
                                        <div class="goods-qrcode" ref="goods-qrcode"></div>
                                    </div>
                                    <div class="qrcode-loading" v-if="loading">
                                        <span class="icon"></span>
                                    </div>
                                    <div class="qrcode-no-login" v-if="isDyyPage || !isLogin">
                                        <div class="no-login-qrcode" ref="no-login"></div>
                                        <div @click="clickQrcode" class="no-login-text" :class="{ dyypage: isDyyPage }">
                                            <template v-if="isDyyPage">
                                                <p>请下载客户端后</p>
                                                <p>进行付款操作</p>
                                            </template>
                                            <template v-else-if="!isLogin">
                                                <p>请登录后</p>
                                                <p>完成支付</p>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="qrcode-succ" v-if="payStatus == 'succ'">
                                        <div class="dv1">支付成功</div>
                                    </div>
                                    <div class="qrcode-invalid" v-if="payStatus == 'fail'">
                                        <div class="dv1">二维码已失效</div>
                                        <div class="dv2" @click="payAgain">刷新</div>
                                    </div>
                                </div>
                                <div class="pay-ways">
                                    <span>支持</span>
                                    <span class="icon zfb-icon" v-if="zfb"></span>
                                    <span class="icon wx-icon" v-if="wx"></span>
                                    <span>扫码支付</span>
                                </div>
                            </div>
                            <div class="right-content">
                                <template v-if="accountType === 'share' || accountType === 'alone'">
                                    <p class="p1">
                                        <span class="sp1">应付金额</span>
                                        <span class="sp2">
                                            <i class="i1">¥</i>
                                            <i class="i2">{{ currentChoosedGoodsSp.current_price }}</i>
                                        </span>
                                        <span class="sp3">原价&nbsp;¥{{ gameInfo.original_price }}</span>
                                    </p>
                                    <p class="p2">为您节约了¥{{ discountPrice }}</p>
                                </template>
                                <template v-else>
                                    <p class="p1">
                                        <span class="sp1">应付金额</span>
                                        <template v-if="currentVipGoods.showOriginPrice">
                                            <span class="sp2 ellipsis">
                                                <i class="i1">¥</i>
                                                <i class="i2">{{ currentVipGoods.original_price }}</i>
                                            </span>
                                        </template>
                                        <template v-else>
                                            <span class="sp2 ellipsis">
                                                <i class="i1">¥</i>
                                                <i class="i2">{{ currentVipGoods.current_price }}</i>
                                            </span>
                                            <span class="sp3" v-if="showVipGoodsOrigin(currentVipGoods)">原价&nbsp;¥{{ currentVipGoods.original_price }}</span>
                                        </template>
                                    </p>
                                    <p class="p2" :style="{ opacity: showVipGoodsOrigin(currentVipGoods) ? 1 : 0 }">为您节约了¥{{ discountPrice }}</p>
                                </template>
                                <p class="p3">
                                    <span>购买即代表阅读并同意</span>
                                    <span class="sp1" @click="clickProtocol">《付费服务协议》</span>
                                </p>
                            </div>
                        </div>
                        <div class="part3-right">
                            <div class="dv1">
                                <span class="sp1"></span>
                                <span class="sp2">
                                    <i class="i1">在线客服</i>
                                    <i class="i2">工作日9:30 - 20:30</i>
                                </span>
                            </div>
                            <div class="dv2 dyypage" v-if="isDyyPage" @click="dlClient" data-agl-cvt="6">请下载客户端后联系客服</div>
                            <div class="dv2 normal" v-else @click="openCustomer">联系客服</div>
                            <div class="dv3">
                                <div class="item item1">
                                    <div class="icon"></div>
                                    <div class="text1">随时退</div>
                                    <div class="text2">共享账号2小时包退</div>
                                </div>
                                <div class="item item2">
                                    <div class="icon"></div>
                                    <div class="text1">安心享</div>
                                    <div class="text2">金牌客服在线支持</div>
                                </div>
                                <div class="item item3">
                                    <div class="icon"></div>
                                    <div class="text1">放心玩</div>
                                    <div class="text2">官方采购正版游戏</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { getLocalGameList } from '@/http/api/game'
import { getVipShopList } from '@/http/api/vip'
import config from '@/http/config'
import QRCode from 'qrcodejs2'
import { Decimal } from 'decimal.js'
import { cancelRequest } from '@/http'
import { getCookieToken, canPlayGame } from '@/utils/auth'
import { createAloneOrder, createVipOrder, queryOrderStatus } from '@/http/api/order'
import { getSpInfo } from '@/http/api/goods'
import { getUserVipInfo } from '@/http/api/user'

export default {
    name: 'BuyVipDialog',
    data() {
        return {
            isShow: false,
            gameInfo: {},
            shareSpInfo: {},
            aloneSpInfo: {},
            vipText: '',
            accountType: '',
            payStatus: '',
            vipGoodsList: [],
            queryTimes: 0, // 查询订单次数
            errorTimes: 0, // 重试次数
            vipGoodsQuery: {
                page: 1,
                size: 3
            },
            loading: true,
            currentChoosedGoodsSp: {
                original_price: '--'
            },
            channel: 'baidutg', // 和获取会员商品有关系，直接写死
            shopsGoodsSp: [], // 独享规格关联的乐速商城的商品规格列表
            currentVipGoods: {}
        }
    },
    computed: {
        ...mapState(['userInfo', 'authInfo', 'payAgreement']),
        ...mapGetters(['isDyyPage', 'customerLink']),
        username: function () {
            const name = this.userInfo.name,
                reg = /^1[3-9]\d{9}$/
            let displayNmae = ''
            if (reg.test(name)) {
                displayNmae = this.$Utils.formatPhoneNumber(name)
            } else {
                displayNmae = name
            }
            return displayNmae
        },
        wx() {
            return this.$store.state.payConfig.wx
        },
        zfb() {
            return this.$store.state.payConfig.zfb
        },
        isLogin() {
            return this.userInfo.id
        },
        discountPrice() {
            if (this.accountType === 'vip') {
                const { original_price, current_price } = this.currentVipGoods
                return new Decimal(original_price).minus(new Decimal(current_price)).toNumber()
            } else {
                const original_price = this.gameInfo.original_price
                const current_price = this.currentChoosedGoodsSp.current_price
                if (!isNaN(original_price) && !isNaN(current_price)) {
                    return new Decimal(original_price).minus(new Decimal(current_price)).toNumber()
                } else {
                    return '--'
                }
            }
        },
        showVipGoodsOrigin() {
            return (item) => {
                return item.original_price * 100 !== item.current_price * 100 && item.original_price * 100 > item.current_price * 100
            }
        }
    },
    watch: {
        isShow: function (value) {
            if (value) {
                this.$nextTick(() => {
                    this.$Utils.setDialogZindex('buy-vip-page')
                    // 获取视口高度
                    const viewportHeight = document.documentElement.clientHeight || document.body.clientHeight
                    const realContentHeight = this.$refs.buyVipContent.querySelector('.real-content').offsetHeight
                    if (viewportHeight > realContentHeight) {
                        const marginTopAndBottom = (viewportHeight - realContentHeight) / 2
                        this.$refs.buyVipContent.querySelector('.real-content').style = `margin: ${marginTopAndBottom}px auto;`
                    }

                    if (!getCookieToken() || this.isDyyPage) {
                        this.creatQrCode(`${config.WEB_DOMAIN}`, 'no-login')
                    }
                })
            } else {
                this.gameInfo = {}
            }
        },
        '$store.state.serverTime': function () {
            this.vipText = this.$Utils.showVipText()
        }
    },
    methods: {
        show(payload) {
            this.isShow = true
            if (payload && payload instanceof Object) {
                this.gameInfo = payload
                this.getLocalGameList(payload.game_id)
                this.getVipGoodsData()
            }
            this.$EventBus.$on('create-order', () => {
                this.createOrder()
            })
        },
        close() {
            this.isShow = false
            this.gameInfo = {}
            this.shareSpInfo = {}
            this.aloneSpInfo = {}
            this.vipText = ''
            this.accountType = ''
            this.payStatus = ''
            this.vipGoodsList = []
            this.loading = true
            this.currentChoosedGoodsSp = {
                original_price: '--'
            }
            this.shopsGoodsSp = []
            this.currentVipGoods = {}
            this.resetData()
            this.$EventBus.$off('create-order')
        },
        // 处理鼠标滚轮事件-阻止滚动穿透
        handleWheel(e) {
            const element = this.$refs.buyVipContent
            const { scrollTop, scrollHeight, clientHeight } = element

            // 阻止事件冒泡到底层页面
            e.stopPropagation()

            // 如果容器已经滚动到顶部或底部，阻止默认滚动行为
            if (e.deltaY < 0 && scrollTop === 0) {
                // 向上滚动且已经到顶部
                e.preventDefault()
            } else if (e.deltaY > 0 && scrollTop + clientHeight >= scrollHeight) {
                // 向下滚动且已经到底部
                e.preventDefault()
            }
        },
        clickProtocol() {
            if (this.isDyyPage) {
                return
            } else {
                window.open(this.payAgreement, '_blank')
            }
        },
        clickQrcode() {
            if (this.isDyyPage) {
                this.$EventBus.$emit('app-dl')
            }
        },
        dlClient() {
            this.$EventBus.$emit('app-dl')
        },
        openCustomer() {
            window.open(this.customerLink, '_blank')
        },
        openAuth() {
            this.$Auth.show('create-order')
        },
        openLogin() {
            this.$Login.show({
                scene: 'cb',
                callback: () => {
                    this.createOrder()
                }
            })
        },
        // 根据游戏ID获取关联的盒子商品列表
        getLocalGameList(game_id) {
            const query = {
                steamAppid: '[]',
                game_id
            }

            getLocalGameList(query).then((res) => {
                if (res.code == 200 && res.data) {
                    const goods = res.data.list?.[0]?.goodsList || []
                    // 会存在一个游戏关联多个盒子商品的情况，线上环境有一个游戏PUBG，会存在这种情况
                    // 运营自己手动控制展示，咱们这边不用考虑特殊情况，默认取第一个商品
                    const firstGoods = goods[0]
                    if (firstGoods && firstGoods.is_enable) {
                        this.shareSpInfo = firstGoods?.goodsSpecifications.find((item) => item.is_enable && item.mode === 1 && item.is_sell === 1) || {}
                        this.tempAloneSpList = firstGoods?.goodsSpecifications.filter((item) => item.mode === 3) || []

                        const relation_ids = this.tempAloneSpList.map((v) => v.relation_id)
                        this.judgeSpInventory({ sids: JSON.stringify(relation_ids) }, async () => {
                            const buyRes = await this.$Utils.isBuyGoods(this.shareSpInfo.g_id, this.shareSpInfo.id)
                            if (this.shareSpInfo.id && !buyRes) {
                                this.accountType = 'share'
                                this.currentChoosedGoodsSp = this.shareSpInfo
                                this.$set(this.shareSpInfo, 'can_choose', true)
                            } else if (this.aloneSpInfo.can_choose) {
                                this.accountType = 'alone'
                                this.currentChoosedGoodsSp = this.shopsGoodsSp[0]
                            }

                            // 如果共享规格和独享规格都不可以选中，选中第一个VIP商品
                            if (!this.accountType) {
                                await this.loopVipGoods()
                            }

                            // 创建订单
                            if (getCookieToken()) {
                                this.createOrder()
                            }
                        })
                    }
                }
            })
        },
        // 获取vip商品列表--读取会员商品时，固定传入渠道
        getVipGoodsData() {
            getVipShopList({ ...this.vipGoodsQuery, channel: 'baidutg' }).then((res) => {
                if (res.code == 200 && this.$Utils.isObject(res.data)) {
                    const { list } = res.data
                    this.vipGoodsList = list.map((v) => {
                        v.showOriginPrice = false
                        try {
                            let formatChannel = JSON.parse(v.channel)
                            if (this.$Utils.isObject(formatChannel)) {
                                let priceChannel = formatChannel.price_channel
                                if (Array.isArray(priceChannel) && priceChannel.indexOf(this.channel) > -1) {
                                    v.showOriginPrice = true
                                }
                            }
                        } catch (error) {}
                        return v
                    })
                }
            })
        },
        // 通过独享规格关联的商品ID，去查找对应的规格信息
        judgeSpInventory(query, func) {
            const parseQuerySids = JSON.parse(query.sids)
            try {
                if (!parseQuerySids.length) {
                    func && func()
                    return
                }
            } catch (error) {
                func && func()
                return
            }

            getSpInfo(query)
                .then((res) => {
                    if (res.code == 200 && Array.isArray(res.data.goodsSpecification)) {
                        let tempData = res.data.goodsSpecification

                        for (let i = 0; i < tempData.length; i++) {
                            const v = tempData[i]
                            const aloneSp = this.tempAloneSpList.find((item) => item.relation_id === v.id)
                            const aloneSpIndex = this.tempAloneSpList.findIndex((item) => item.relation_id === v.id)
                            aloneSp.can_choose = true
                            if (v.is_enable === 0 || (v.type === 'CDK' && v.is_stock === 1 && v.inventory <= 0)) {
                                aloneSp.can_choose = false
                            }
                            this.tempAloneSpList[aloneSpIndex] = aloneSp
                        }

                        // 获取独享规格id最小的那个并且关联商品规格是可以选择的 （优先从选中规格中挑选、然后再从非选中的规格中挑选）
                        const targetDefaultAloneSpInfo = this.tempAloneSpList.filter((v) => v.can_choose && v.is_select === 1).sort((a, b) => a.id - b.id)[0]
                        const targetAloneSpInfo = this.tempAloneSpList.filter((v) => v.can_choose && v.is_select === 0).sort((a, b) => a.id - b.id)[0]
                        const targetInfo = targetDefaultAloneSpInfo || targetAloneSpInfo

                        if (targetInfo) {
                            this.aloneSpInfo = targetInfo
                            this.validShopsInfo = tempData.find((v) => v.id === this.aloneSpInfo.relation_id)
                            this.shopsGoodsSp = [this.validShopsInfo]
                        }
                        func && func()
                    } else {
                        func && func()
                    }
                })
                .catch((err) => {
                    func && func()
                    console.log('[judgeSpInventory]]=======>', err)
                })
        },
        // 创建订单
        async createOrder() {
            if (this.isDyyPage) {
                return false
            }

            if (!getCookieToken()) {
                return this.$Login.show({
                    scene: 'cb',
                    callback: () => {
                        this.createOrder()
                    }
                })
            }

            // 等待获取实名信息
            await this.$Utils.waitForAuthInfo()
            // 是否实名认证过
            if (!canPlayGame(this, 'create-order')) {
                return false
            }

            await this.judgeChooseShareGoods()
            if (!this.accountType) {
                return false
            }
            let data = {}
            if (this.accountType === 'share' || this.accountType === 'vip') {
                data = {
                    g_id: this.accountType === 'vip' ? this.currentVipGoods.id : this.currentChoosedGoodsSp.id,
                    client_ip: this.$store.state.client_ip,
                    channel: this.$Utils.getNowChannel(),
                    type: this.accountType === 'vip' ? 0 : 1, // 0:会员，1:共享
                    location: 'box',
                    img: this.accountType === 'vip' ? '' : this.gameInfo.cover_image_url
                }
                if (this.accountType === 'vip') {
                    data.location_gid = 0
                }
                this.createType = createVipOrder
                this.orderPrefix = 'BOX'
            } else {
                let img = ''
                try {
                    img = JSON.parse(this.currentChoosedGoodsSp.goodsImgs)[0]
                } catch (error) {}
                data = {
                    channel: this.$Utils.getNowChannel(),
                    gName: this.currentChoosedGoodsSp.goodName,
                    client_ip: this.$store.state.client_ip,
                    gid: this.currentChoosedGoodsSp.gid,
                    gsid: this.currentChoosedGoodsSp.id,
                    img,
                    nums: 1,
                    location: 'box'
                }
                this.createType = createAloneOrder
                this.orderPrefix = 'SH'
            }

            let current_price = 0
            if (this.accountType === 'vip') {
                const { showOriginPrice, original_price } = this.currentVipGoods
                current_price = showOriginPrice ? original_price : this.currentVipGoods.current_price
            } else {
                current_price = this.currentChoosedGoodsSp.current_price
            }
            this.loading = true
            this.$refs['goods-qrcode'] && (this.$refs['goods-qrcode'].innerHTML = '')
            this.createType(data)
                .then((res) => {
                    this.loading = false
                    if (res && this.$Utils.isObject(res.data)) {
                        let url = config.WEB_DOMAIN + `/commonPay.html?orderId=${res.data.id}&orderPrefix=${this.orderPrefix}&orderMoney=${current_price}`
                        const { id } = res.data
                        this.orderId = id
                        this.creatQrCode(url)
                        this.queryStatus(id)
                        this.current_price = current_price

                        const bd_vid = this.$cookies.get('bd_vid')
                        if (bd_vid) {
                            this.$Utils.report({ event: 'ocpc上报', event_id: 40, n2: 0, v1: 'pay', v2: bd_vid, v3: 'box_web', f1: this.current_price })
                        }
                    } else {
                        this.$NormalDialog.show({
                            title: '提示',
                            msg: res.msg
                        })
                    }
                })
                .catch((err) => {
                    this.loading = false
                    console.log('[createOrder]=======>', err)
                })
        },
        // 创建二维码
        creatQrCode(url, ref = 'goods-qrcode') {
            console.log(`二维码地址[${ref}]=======>`, url)
            this.qrcode = new QRCode(this.$refs[ref], {
                text: url,
                width: 135,
                height: 135,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })

            this.$nextTick(() => {
                this.$refs[ref].title = ''
            })
        },
        // 查询订单状态
        queryStatus(orderId) {
            clearTimeout(this.queryStatusTimeId)
            clearTimeout(this.queryRetryTimeId)
            if (!orderId) {
                return false
            }

            let timeCell = 1000
            this.queryTimes++

            // 根据查询的次数
            if (this.queryTimes < 60) {
                timeCell = 1000
            } else if (this.queryTimes < 120) {
                timeCell = 1500
            } else if (this.queryTimes < 180) {
                timeCell = 2000
            } else if (this.queryTimes < 240) {
                timeCell = 2500
            } else {
                timeCell = 3000
            }

            queryOrderStatus({ orderId, orderPrefix: this.orderPrefix })
                .then((res) => {
                    if (res.code == 200 && this.$Utils.isObject(res.data)) {
                        const { status } = res.data
                        if (!status) {
                            // 未支付
                            this.queryStatusTimeId = setTimeout(() => {
                                this.queryStatus(orderId)
                            }, timeCell)
                        } else if (status == 1) {
                            // 支付成功
                            this.payStatus = 'succ'
                            this.queryTimes = 0
                            this.errorTimes = 0
                            let msg = '您已成功购买，请下载客户端进行游玩'
                            let confirmTxt = '点击下载客户端'
                            if (this.accountType === 'alone') {
                                msg = '您已成功购买，请跳转商城领取账号 '
                                confirmTxt = '点击跳转商城'
                            }

                            const saveAccountType = this.accountType
                            this.$PayGoodsSuccDialog.show({
                                confirmTxt,
                                msg,
                                confirmFn: () => {
                                    if (saveAccountType === 'alone') {
                                        const targetUrl = `${config.WEB_DOMAIN}/personal_center.html?_ts=${Date.now()}`
                                        const url = `token=${getCookieToken()}&targetUrl=${encodeURIComponent(targetUrl)}`
                                        window.open(`${config.WEB_DOMAIN}/redirect.html?${url}`, '_blank')
                                    } else {
                                        this.$EventBus.$emit('app-dl')
                                    }
                                }
                            })

                            if (this.accountType === 'vip') {
                                this.$Utils.loopQueryVipInfo()
                            } else if (this.accountType === 'share') {
                                this.$store.dispatch('userVipInfoAction')
                            }

                            this.close()
                        } else {
                            this.payStatus = 'fail'
                        }
                    } else {
                        // 查询接口非200状态码
                        this.queryStatusTimeId = setTimeout(() => {
                            this.queryStatus(orderId)
                        }, timeCell)
                    }
                })
                .catch((err) => {
                    // 网络错误、服务器挂了等其他情况，3s后重试，重试次数最大60次
                    if (this.errorTimes < 60) {
                        this.queryRetryTimeId = setTimeout(() => {
                            this.queryStatus(orderId)
                        }, 3000)
                    } else {
                        this.$Toast.show('查询订单状态失败')
                        console.log('[queryStatus]=======>', err)
                    }
                    this.errorTimes++
                })
        },
        payAgain() {
            this.resetData()
            this.createOrder()
        },
        resetData() {
            this.queryTimes = 0
            this.errorTimes = 0
            this.payStatus = ''
            clearTimeout(this.queryStatusTimeId)
            clearTimeout(this.queryRetryTimeId)
            cancelRequest('/shops/createCdkOrder')
            cancelRequest('/order/getOrderStatus')
            cancelRequest('/box/member/createOrder')
        },
        chooseAccountType(value) {
            if (value === this.accountType) {
                return false
            }

            this.accountType = value
            if (value === 'share') {
                this.currentChoosedGoodsSp = this.shareSpInfo
            } else if (value === 'alone') {
                this.currentChoosedGoodsSp = this.shopsGoodsSp[0]
            }

            this.currentVipGoods = {}
            this.resetData()
            if (getCookieToken()) {
                this.createOrder()
            }
        },
        clickVipGoods(item) {
            this.accountType = 'vip'
            this.currentVipGoods = item
            this.currentChoosedGoodsSp = {}
            this.resetData()
            if (getCookieToken()) {
                this.createOrder()
            }
        },
        // 支付成功后查询会员信息
        loopQueryVipInfo() {
            clearTimeout(this.loopVipInfoTimeId)
            getUserVipInfo().then(async (res) => {
                if (res.code == 200) {
                    const { expire_time: localExpireTime, hourly_expire_time: localHourlyExpireTime } = this.$store.state.vipInfo
                    // 本地的包时会员和计时会员的过期时间，如果其中一个和服务端返回的不同，则更新
                    // 否则继续循环查询
                    const { expire_time, hourly_expire_time } = res.data
                    if (localExpireTime != expire_time || localHourlyExpireTime != hourly_expire_time) {
                        this.$store.commit('setUserVipInfo', res.data)
                    } else {
                        this.loopVipInfoTimeId = setTimeout(() => {
                            this.loopQueryVipInfo()
                        }, 1000)
                    }
                }
            })
        },
        // 登录成功之后，判断是否选择的是共享会员规格
        judgeChooseShareGoods() {
            return new Promise(async (resolve) => {
                if (this.accountType === 'share') {
                    const buyRes = await this.$Utils.isBuyGoods(this.shareSpInfo.g_id, this.shareSpInfo.id)
                    console.log('2=======>', buyRes)
                    if (buyRes) {
                        this.accountType = ''
                        this.$set(this.shareSpInfo, 'can_choose', false)
                        if (this.aloneSpInfo.can_choose) {
                            this.accountType = 'alone'
                            this.currentChoosedGoodsSp = this.shopsGoodsSp[0]
                        } else if (this.vipGoodsList[0]) {
                            this.accountType = 'vip'
                            this.currentVipGoods = this.vipGoodsList[0]
                        }
                        resolve()
                        return
                    }
                }
                resolve()
            })
        },
        // 循环查询第一个VIP商品
        loopVipGoods() {
            return new Promise((resolve, reject) => {
                let times = 0
                this.getVipGoodsTimeId = setInterval(() => {
                    times++
                    if (this.vipGoodsList[0]) {
                        clearInterval(this.getVipGoodsTimeId)
                        this.accountType = 'vip'
                        this.currentVipGoods = this.vipGoodsList[0]
                        resolve()
                        return
                    }

                    if (times >= 50) {
                        clearInterval(this.getVipGoodsTimeId)
                        reject(new Error('获取VIP商品超时'))
                    }
                }, 100)
            })
        }
    }
}
</script>
<style lang="less" scoped>
.buy-vip-page {
    .buy-vip-content {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        letter-spacing: initial;

        .real-content {
            margin: 0 auto;
            position: relative;
            width: 953px;
            height: 804px;
            padding: 24px 40px 0 40px;
            border: 1px solid rgba(255, 255, 255, 0.1);
            background: #1e1e1e;

            .title {
                text-align: center;
                color: #ffffff;
                font-size: 20px;
                font-weight: 700;
                line-height: 30px;
                margin-bottom: 17px;
            }

            .part1,
            .part2 {
                .part1-cont,
                .part2-cont {
                    display: flex;

                    .line {
                        margin-left: 10px;
                        margin-right: 21px;
                        border-left: 1px dashed #8e8e90;
                    }
                }
            }

            .part1 {
                margin-bottom: 24px;

                .part1-text {
                    display: flex;
                    align-items: center;
                    margin-bottom: 6px;

                    .sp1 {
                        width: 20px;
                        height: 20px;
                        border-radius: 10px;
                        font-size: 14px;
                        line-height: 20px;
                        text-align: center;
                        color: rgb(0, 235, 87);
                        background-color: rgba(0, 241, 78, 0.2);
                    }

                    .sp2 {
                        margin-left: 12px;
                        color: rgb(255, 255, 255);
                        font-size: 15px;
                        line-height: 23px;
                    }
                }

                .part1-cont {
                    .line {
                        height: 203px;
                    }

                    .account-buy {
                        margin-top: 6px;
                        width: 413px;
                        height: 208px;
                        border-radius: 4px;
                        background: #28292c;
                        padding: 20px 32px;

                        .p1 {
                            color: #ffffff;
                            font-size: 16px;
                            line-height: 21px;
                            margin-bottom: 13px;
                        }

                        .sp {
                            padding-left: 17px;
                            padding-right: 24px;
                            width: 349px;
                            height: 60px;
                            border-radius: 4px;
                            display: flex;
                            align-items: center;
                            border: 1px solid transparent;
                            cursor: pointer;

                            &.active {
                                border: 1px solid #00eb57;
                            }

                            .sp-left {
                                flex-shrink: 0;
                                display: flex;
                                align-items: center;

                                .i1 {
                                    width: 20px;
                                    height: 20px;
                                }
                            }

                            .sp-center {
                                flex: 1;
                                text-align: center;

                                .price1 {
                                    color: rgb(248, 210, 154);
                                    font-size: 18px;
                                    font-weight: bold;
                                    line-height: 24px;
                                    margin-right: 4px;
                                }

                                .price2 {
                                    color: rgb(150, 150, 152);
                                    font-size: 12px;
                                    text-decoration-line: line-through;
                                }
                            }

                            .sp-right {
                                flex-shrink: 0;
                                width: 78px;

                                .text1,
                                .text2 {
                                    color: rgb(150, 150, 152);
                                    font-size: 12px;
                                    line-height: 16px;
                                    text-align: right;
                                }
                            }
                        }

                        .share-sp {
                            margin-bottom: 12px;
                            background: linear-gradient(90deg, #00eb571a 0%, #02cb8a1a 100%);

                            .sp-left {
                                .i1 {
                                    background: url(../../../assets/share-icon.png) no-repeat center/100%;
                                }

                                .sp1 {
                                    margin-left: 4px;
                                    color: #ffffff;
                                    font-size: 14px;
                                    line-height: 18px;
                                }
                            }

                            .sp-center {
                                padding-left: 33px;
                            }
                        }

                        .alone-sp {
                            background: linear-gradient(90deg, #4f4131 0%, #36312d 100%);

                            .sp-left {
                                .i1 {
                                    background: url(../../../assets/alone-icon.png) no-repeat center/100%;
                                }

                                .dv1 {
                                    width: 65px;

                                    .text1 {
                                        color: #ffffff;
                                        font-size: 14px;
                                        line-height: 18px;
                                    }

                                    .text2 {
                                        color: rgba(255, 255, 255, 0.7);
                                        font-size: 12px;
                                        font-weight: 400;
                                        line-height: 16px;
                                        margin-top: 2px;
                                    }
                                }
                            }
                        }
                    }

                    .vip-buy {
                        margin-top: 6px;
                        margin-left: 16px;
                        padding: 20px 32px;
                        width: 412px;
                        height: 208px;
                        border-radius: 4px;
                        background: linear-gradient(128deg, rgba(0, 235, 87, 0.1) 4.8%, rgba(0, 0, 0, 0.1) 68.75%), #28292c;

                        .vip-buy-title {
                            display: flex;
                            margin-bottom: 14px;

                            .sp1 {
                                width: 22px;
                                height: 22px;
                                background: url(../../../assets/vip-icon1.png) no-repeat center/100%;
                            }

                            .sp2 {
                                margin-left: 8px;
                                color: #fff;
                                font-size: 16px;
                                line-height: 21px;
                            }
                        }

                        .goods-wrap {
                            .goods-item {
                                position: relative;
                                height: 40px;
                                margin-bottom: 8px;
                                border-radius: 4px;
                                padding: 0 25px 0 22px;
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                cursor: pointer;

                                &::after {
                                    position: absolute;
                                    box-sizing: border-box;
                                    content: '';
                                    top: 0;
                                    left: 0;
                                    width: 100%;
                                    height: 100%;
                                    border-radius: 4px;
                                    border: 1px solid rgba(255, 255, 255, 0.15);
                                }

                                &.active {
                                    &::after {
                                        border-color: #00eb57;
                                    }
                                }

                                .sp1 {
                                    display: flex;
                                    align-items: center;

                                    .i1 {
                                        width: 24px;
                                        height: 24px;
                                        background: url(../../../assets/vip-icon2.png) no-repeat center/100%;
                                    }

                                    .i2 {
                                        width: 155px;
                                        margin-left: 7px;
                                        color: rgb(255, 255, 255);
                                        font-size: 14px;
                                        font-weight: bold;
                                        line-height: 18px;
                                    }
                                }

                                .sp2 {
                                    display: flex;
                                    flex: 1;
                                    align-items: flex-end;
                                    padding-left: 20px;

                                    .i1,
                                    .i2 {
                                        color: #f8d29a;
                                        font-weight: 700;
                                        margin-right: 2px;
                                    }

                                    .i1,
                                    .i3 {
                                        position: relative;
                                        top: -2px;
                                    }

                                    .i1 {
                                        font-size: 14px;
                                        line-height: 18px;
                                    }

                                    .i2 {
                                        font-size: 20px;
                                        line-height: 26px;
                                    }

                                    .i3 {
                                        color: #999999;
                                        font-size: 12px;
                                        line-height: 16px;
                                        text-decoration-line: line-through;
                                    }
                                }

                                .sp3 {
                                    width: 78px;
                                    color: #999999;
                                    text-align: right;
                                    font-size: 12px;
                                    line-height: 16px;
                                }

                                .sp1,
                                .sp3 {
                                    flex-shrink: 0;
                                }
                            }

                            .goods-item:nth-child(1) {
                                background: linear-gradient(90deg, #786540 0%, #35291d 100%);
                            }

                            .goods-item:nth-child(2) {
                                background: linear-gradient(90deg, #394b4e 0%, #1d3135 100%);
                            }

                            .goods-item:nth-child(3) {
                                background: linear-gradient(90deg, #394b4e 0%, #1d3135 100%);
                            }
                        }
                    }
                }
            }

            .part2 {
                margin-bottom: 8px;

                .part2-cont {
                    .line {
                        height: 117px;
                    }

                    .part2-info {
                        margin-top: 10px;
                        width: 841px;
                        height: 90px;
                        border-radius: 4px;
                        background: #28292c;

                        .btn {
                            margin: 25px auto 0;
                            width: 294px;
                            height: 40px;
                            border-radius: 4px;
                            background: rgba(255, 255, 255, 0.1);
                            color: rgba(255, 255, 255, 0.6);
                            text-align: center;
                            font-size: 15px;
                            line-height: 40px;
                            cursor: pointer;
                        }

                        .user-info {
                            padding: 16px 32px;

                            .dv1,
                            .dv2 {
                                display: flex;
                                margin-bottom: 16px;

                                .sp {
                                    color: #bfbfbf;
                                    font-size: 14px;
                                    line-height: 21px;
                                    width: 226px;

                                    .cert {
                                        cursor: pointer;
                                        color: #00eb57;
                                    }
                                }

                                .sp1 {
                                    padding-right: 10px;
                                }
                            }

                            .dv1 {
                                .sp2 {
                                    flex: 1;
                                }
                            }

                            .dv2 {
                                .sp2 {
                                    width: 303px;
                                    padding-left: 45px;
                                }
                            }
                        }
                    }
                }
            }

            .part2,
            .part3 {
                .part2-text,
                .part3-text {
                    display: flex;
                    align-items: center;
                    margin-bottom: 6px;

                    .sp1 {
                        width: 20px;
                        height: 20px;
                        border-radius: 10px;
                        font-size: 14px;
                        line-height: 20px;
                        text-align: center;
                        color: #1e1e1e;
                        background-color: #666666;
                    }

                    .sp2 {
                        margin-left: 12px;
                        color: #666666;
                        font-size: 15px;
                        line-height: 23px;
                    }
                }
            }

            .part3 {
                .part3-cont {
                    display: flex;
                    padding-left: 32px;

                    .part3-left {
                        display: flex;
                        width: 491px;
                        height: 235px;
                        padding: 26px 0 0 32px;
                        border-radius: 4px;
                        background: #28292c;
                        margin-right: 16px;

                        .left-content {
                            width: 153px;
                            margin-right: 39px;

                            .qrcode-wrap {
                                width: 153px;
                                height: 153px;
                                position: relative;
                                border-radius: 10px;

                                .qrcode-section {
                                    position: absolute;
                                    z-index: 2;
                                    width: 100%;
                                    height: 100%;
                                    top: 50%;
                                    left: 50%;
                                    transform: translate(-50%, -50%);
                                    background-color: #d9d9d9;
                                    border-radius: 10px;

                                    .goods-qrcode {
                                        position: absolute;
                                        width: 135px;
                                        height: 135px;
                                        top: 50%;
                                        left: 50%;
                                        transform: translate(-50%, -50%);

                                        ::v-deep img {
                                            width: 100%;
                                            height: 100%;
                                        }
                                    }
                                }

                                .qrcode-loading {
                                    position: absolute;
                                    z-index: 3;
                                    width: 100%;
                                    height: 100%;
                                    top: 50%;
                                    left: 50%;
                                    transform: translate(-50%, -50%);
                                    background: #d9d9d9;
                                    border-radius: 10px;

                                    .icon {
                                        width: 32px;
                                        height: 32px;
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        transform: translate(-50%, -50%);
                                        background: url(../../../assets/dialog/loading.gif) center/100% no-repeat;
                                    }
                                }

                                .qrcode-no-login {
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: 153px;
                                    height: 153px;
                                    z-index: 3;

                                    .no-login-qrcode {
                                        position: absolute;
                                        width: 135px;
                                        height: 135px;
                                        top: 50%;
                                        left: 50%;
                                        transform: translate(-50%, -50%);

                                        ::v-deep img {
                                            width: 100%;
                                            height: 100%;
                                        }
                                    }

                                    .no-login-text {
                                        position: absolute;
                                        padding-top: 54px;
                                        top: -1px;
                                        left: -1px;
                                        width: 155px;
                                        height: 155px;
                                        background-color: rgba(0, 0, 0, 0.4);
                                        color: rgb(255, 255, 255);
                                        text-align: center;
                                        font-size: 15px;
                                        line-height: 23px;
                                        border-radius: 10px;
                                        backdrop-filter: blur(4px);
                                        box-shadow: 0 0 15px rgba(0, 0, 0, 0.4);

                                        &.dyypage {
                                            cursor: pointer;
                                        }
                                    }
                                }

                                .qrcode-succ,
                                .qrcode-invalid {
                                    position: absolute;
                                    width: 100%;
                                    height: 100%;
                                    top: 50%;
                                    left: 50%;
                                    transform: translate(-50%, -50%);
                                    background: linear-gradient(#000000b3, #000000b3);
                                    z-index: 3;
                                    display: flex;
                                    flex-direction: column;
                                    align-items: center;
                                    justify-content: center;
                                    border-radius: 9px;

                                    .dv1 {
                                        text-align: center;
                                        line-height: 23px;
                                        color: @color-txt-high;
                                        font-size: 18px;
                                    }

                                    .dv2 {
                                        margin: 17px auto 0;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        width: 96px;
                                        height: 32px;
                                        border-radius: 43px;
                                        background: linear-gradient(90.64deg, #ffe0c1 0.41%, #f2ab74 100.09%);
                                        color: #6b3d1e;
                                        font-weight: 600;
                                        font-size: 16px;
                                        cursor: pointer;
                                    }
                                }
                            }

                            .pay-ways {
                                margin-top: 12px;
                                display: flex;
                                align-items: center;
                                justify-content: center;

                                span {
                                    margin: 0 4px 0 0;
                                    font-size: 12px;
                                    color: #ffffff;

                                    &:last-child {
                                        margin-right: 0;
                                    }
                                }

                                .icon {
                                    width: 18px;
                                    height: 18px;

                                    &.wx-icon {
                                        background: url(../../../assets/wx-icon.png) center no-repeat;
                                        background-size: 100% 100%;
                                    }

                                    &.zfb-icon {
                                        background: url(../../../assets/zfb-icon.png) center no-repeat;
                                        background-size: 100% 100%;
                                    }
                                }
                            }
                        }

                        .right-content {
                            margin-top: 19px;

                            .p1 {
                                margin-bottom: 16px;

                                .sp1 {
                                    color: rgb(255, 255, 255);
                                    font-size: 14px;
                                    line-height: 18px;
                                }

                                .sp2 {
                                    color: #f8d29a;
                                    font-weight: bold;

                                    .i1 {
                                        font-size: 14px;
                                        line-height: 18px;
                                        margin: 0 2px;
                                    }

                                    .i2 {
                                        font-size: 28px;
                                        line-height: 37px;
                                    }
                                }

                                .sp3 {
                                    margin-left: 13px;
                                    color: rgba(255, 255, 255, 0.4);
                                    font-size: 14px;
                                    line-height: 18px;
                                    text-decoration-line: line-through;
                                }
                            }

                            .p2 {
                                margin: 0 0 30px 18px;
                                width: 174px;
                                height: 28px;
                                color: #f8d29a;
                                text-align: center;
                                font-size: 13px;
                                line-height: 28px;
                                background: url(../../../assets/discount-bg.png) no-repeat center/100% 100%;
                            }

                            .p3 {
                                color: #969698;
                                font-size: 13px;
                                line-height: 17px;
                                text-align: center;

                                .sp1 {
                                    cursor: pointer;
                                    color: #ffffff;
                                    font-size: 13px;
                                }
                            }
                        }
                    }

                    .part3-right {
                        width: 334px;
                        height: 235px;
                        background: #28292c;

                        .dv1 {
                            padding: 20px 0 0 30px;
                            margin-bottom: 16px;
                            display: flex;
                            align-items: center;

                            .sp1 {
                                width: 32px;
                                height: 32px;
                                background: url(../../../assets/kf-icon.png) no-repeat center/100%;
                            }

                            .sp2 {
                                margin-left: 14px;
                                display: flex;
                                align-items: center;
                                flex-wrap: wrap;

                                i {
                                    width: 100%;
                                }

                                .i1 {
                                    color: #ffffff;
                                    font-size: 16px;
                                    line-height: 21px;
                                    margin-bottom: 8px;
                                }

                                .i2 {
                                    color: #969698;
                                    font-size: 13px;
                                    line-height: 17px;
                                }
                            }
                        }

                        .dv2 {
                            width: 294px;
                            margin: 0 auto;
                            cursor: pointer;
                            height: 36px;
                            border-radius: 4px;
                            text-align: center;
                            font-size: 15px;
                            line-height: 36px;
                            text-align: center;

                            &.dyypage {
                                background: rgba(255, 255, 255, 0.1);
                                color: rgba(255, 255, 255, 0.6);
                            }

                            &.normal {
                                color: #00eb57;
                                background: linear-gradient(93deg, #00f14e1a -17.79%, #02cb8a1a 80.56%);
                            }
                        }

                        .dv3 {
                            margin-top: 18px;
                            display: flex;
                            justify-content: center;

                            .item {
                                flex: 1;
                                flex-shrink: 0;

                                .icon {
                                    margin: 0 auto;
                                    width: 38px;
                                    height: 38px;
                                }

                                .text1 {
                                    margin: 7px auto 1px;
                                    text-align: center;
                                    color: rgba(255, 255, 255, 0.6);
                                    font-size: 13px;
                                    line-height: 20px;
                                }

                                .text2 {
                                    text-align: center;
                                    color: rgba(255, 255, 255, 0.3);
                                    font-size: 11px;
                                    line-height: 17px;
                                }
                            }

                            .item1 {
                                .icon {
                                    background: url(../../../assets/su-icon.png) no-repeat center/100%;
                                }
                            }

                            .item2 {
                                .icon {
                                    background: url(../../../assets/bao-icon.png) no-repeat center/100%;
                                }
                            }

                            .item3 {
                                .icon {
                                    background: url(../../../assets/zhen-icon.png) no-repeat center/100%;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
